export interface User {
  id: number;
  nodeId: number;
  email: string;
  username: string;
  firstname?: string;
  lastname?: string;
  birthday: string;
  gender: number;
  lastActivity: string;
  isActive: boolean;
  bio?: string;
  city?: string;
  country?: string;
  occupation?: string;
  education?: string;
  lookingFor?: string;
  photoUrl?: string;
  nodeTypeId?: number;
  /** Verified mobile (E.164), empty until the signup phone step is done. */
  phone?: string;
  isPhoneVerified?: boolean;
}

// Aligned with the legacy NodeHuman::getRoles() mapping:
// 1 = ROLE_USER, 6 = ROLE_MODERATOR, 7 = ROLE_SUPER_ADMIN.
// The web /admin panel maps to legacy ROLE_SUPER_ADMIN (7) — moderators (6)
// do their RDV moderation on mobile, not in this panel.
export const NODE_TYPES = {
  USER: 1,
  /** ROLE_PENDING_VALIDATION: signup started, phone and/or photo missing. */
  PENDING_VALIDATION: 2,
  MODERATOR: 6,
  ADMIN: 7,
} as const;

/** GET /v1/user/registration */
export interface RegistrationStatus {
  nodeTypeId: number;
  isPhoneVerified: boolean;
  phoneNumber?: string;
  hasPhoto: boolean;
  isComplete: boolean;
  nextStep: 'phone' | 'photo' | 'done';
}

export interface RegisterRequest {
  email: string;
  username: string;
  password: string;
  firstname: string;
  lastname: string;
  birthday: string;
  gender: number;
}

export interface LoginResponse {
  token: string;
  user: User;
}

export interface UserSettings {
  emailNotifications: boolean;
  pushNotifications: boolean;
  messageNotifications: boolean;
  profileVisibility: 'public' | 'private' | 'contacts_only';
  profileVisible: boolean;
  showOnlineStatus: boolean;
  showLastActivity: boolean;
  showLastSeen: boolean;
}
